const IconMoneyPocketColor = ({
  width,
  height,
}: {
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M8.99995 0C6.68681 0 6.68681 1.22369 4.37367 1.22369C4.37367 3.05922 5.53024 2.44737 5.53024 4.89474H12.4697C12.4697 2.44737 13.6262 3.05922 13.6262 1.22369C11.3131 1.22369 11.3131 0 8.99995 0Z'
        fill='#189458'
      />
      <path
        d='M18 12.9474C18 17.6913 13.9706 18 8.99998 18C4.02934 18 -1.52588e-05 17.6913 -1.52588e-05 12.9474C-1.52588e-05 8.20343 3.99998 3.09998 8.99998 3.09998C14 3.09998 18 8.20343 18 12.9474Z'
        fill='#2BB774'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.73482 8.11853C5.03151 8.00518 5.36822 8.14301 5.48689 8.42639L7.18588 12.4833L8.44553 8.47283C8.51895 8.23908 8.7442 8.079 8.9997 8.079C9.2552 8.079 9.48045 8.23908 9.55387 8.47283L10.8135 12.4833L12.5125 8.42639C12.6312 8.14301 12.9679 8.00518 13.2646 8.11853C13.5613 8.23188 13.7056 8.55349 13.5869 8.83686L11.2726 14.3631C11.1812 14.5812 10.9554 14.7204 10.7097 14.7099C10.4639 14.6994 10.2519 14.5417 10.1812 14.3166L8.9997 10.5548L7.81816 14.3166C7.74747 14.5417 7.5355 14.6994 7.28974 14.7099C7.04397 14.7204 6.81816 14.5812 6.7268 14.3631L4.41251 8.83686C4.29384 8.55349 4.43814 8.23188 4.73482 8.11853Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.79255 10.842C3.47301 10.842 3.21397 11.0894 3.21397 11.3946C3.21397 11.6998 3.47301 11.9472 3.79255 11.9472H6.10683V10.842H3.79255ZM11.8925 10.842V11.9472H14.2068C14.5264 11.9472 14.7854 11.6998 14.7854 11.3946C14.7854 11.0894 14.5264 10.842 14.2068 10.842H11.8925Z'
        fill='white'
      />
    </svg>
  )
}

export default IconMoneyPocketColor
